import React, { useContext } from "react";
import "./AgendaEmptyState.css";
import { LuCalendarX, LuPlus } from "react-icons/lu";
import { getAgendaEmptyStateDetails } from "../../utils/agendaUtils";
import { Language } from "../../App";

export default function AgendaEmptyState({
  variant = "explore",
  category = "all",
  title,
  description,
  actionLabel,
  onAction,
}) {
  const { lang } = useContext(Language) || {};
  const dynamicDetails = getAgendaEmptyStateDetails(category, variant, lang);
  const displayTitle = title || dynamicDetails.title;
  const displayDescription = description || dynamicDetails.description;
  const displayActionLabel = actionLabel || dynamicDetails.actionLabel;

  return (
    <section className={`agenda-empty-state agenda-empty-state-${variant}`}>
      <div className="agenda-empty-calendar-icon" aria-hidden="true">
        <div className="agenda-empty-calendar-icon-inner">
          <LuCalendarX />
        </div>
      </div>

      <div className="agenda-empty-state-copy">
        <p className="agenda-empty-state-title">{displayTitle}</p>
        <p>{displayDescription}</p>
      </div>

      {displayActionLabel && onAction && (
        <button
          type="button"
          className="agenda-empty-state-action"
          onClick={onAction}
        >
          <LuPlus aria-hidden="true" />
          <span>{displayActionLabel}</span>
        </button>
      )}
    </section>
  );
}

